import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import { IStaticContentfulImages } from 'src/types/contentful';
import QuoteAndAttribution from 'src/app/molecules/QuoteAndAttribution/QuoteAndAttribution';

const CategoryPiratesQuoteAndAttribution = (): JSX.Element => {
  const image = useStaticQuery<IStaticContentfulImages>(graphql`
    {
      avatar: contentfulAsset(contentful_id: { eq: "4j7ica2i2ECqwPlEspUzk9" }) {
        gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED, width: 128)
      }
    }
  `);

  return (
    <QuoteAndAttribution
      quote={{
        text: 'We launched the Category Design Academy on Mighty Pro in November, and it doubled our revenue before the year was over.',
        type: 'heading',
        size: 'lg',
      }}
      attribution={{
        authorName: {
          text: 'Katrina Kirsch',
          type: 'paragraph',
          size: 'md',
          fontWeight: 'font-weight-semibold',
          lineHeight: 'line-height-text-lg',
        },
        authorTitle: {
          text: 'Head of Publishing & Ops, Category Pirates',
          type: 'paragraph',
          size: 'md',
        },
        avatarWrapper: {
          imageProps: {
            image: image.avatar.gatsbyImageData,
            alt: 'Avatar',
          },
          maxWidth: 64,
        },
      }}
    />
  );
};

export default CategoryPiratesQuoteAndAttribution;
